// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import AnalyticsConsent from "./components/AnalyticsConsent";
import { initializeAnalyticsConsent } from "./analytics/ga4";

initializeAnalyticsConsent();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsConsent />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
